var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "订单改价",
            top: "100px",
            width: "1000px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "title" }, [_vm._v("商品明细")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "acea-row" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.pram.orderItemList,
                        size: "mini",
                        "highlight-current-row": "",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuId",
                          label: "skuID",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuCode",
                          label: "编号",
                          "min-width": "140",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "skuName", label: "名称" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuAttr",
                          label: "销售属性",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuQuantity",
                          label: "数量",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuPrice",
                          label: "单价",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuTotalPrice",
                          label: "总价",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuTotalPrice",
                          label: "图片",
                          "min-width": "90",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return _c("el-image", {
                                staticStyle: { width: "36px", height: "36px" },
                                attrs: {
                                  src: scope.row.skuImg,
                                  "preview-src-list": [scope.row.skuImg],
                                },
                              })
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initloading,
                  expression: "initloading",
                },
              ],
              ref: "pramRef",
              attrs: { model: _vm.pram, "label-width": "200px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单号：", prop: "receiverName" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.pram.orderNo) + "\n\t\t\t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品金额：", prop: "goodsPrice" } },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.pram.goodsPrice) +
                      "\n            \t\t"
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品运费：", prop: "freightPrice" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      max: Number(_vm.details.freightPrice || 0),
                      min: 0,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.freightPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "freightPrice", $$v)
                      },
                      expression: "pram.freightPrice",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "本单最大运费：" + _vm._s(_vm.details.freightPrice || 0)
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "平台优惠：", prop: "discountPrice" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: Number(_vm.pram.goodsPrice || 0),
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.discountPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "discountPrice", $$v)
                      },
                      expression: "pram.discountPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "最终付款金额：", prop: "totalAmt" } },
                [
                  _c(
                    "div",
                    { staticStyle: { color: "red", "font-weight": "600" } },
                    [_c("div", [_vm._v(_vm._s(_vm.totalAmt))])]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }